import { useTheme } from '@mui/material';

export default function SentimentRecommendationIcon() {
  const theme = useTheme();
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='32' height='32' rx='16' fill={theme.palette.primary.light} />
      <path
        d='M14.9486 17.7798C14.9032 17.6038 14.8115 17.4432 14.683 17.3147C14.5545 17.1862 14.3939 17.0944 14.2179 17.049L11.0979 16.2445C11.0447 16.2294 10.9979 16.1973 10.9645 16.1532C10.9311 16.1091 10.9131 16.0552 10.9131 15.9999C10.9131 15.9446 10.9311 15.8907 10.9645 15.8466C10.9979 15.8025 11.0447 15.7704 11.0979 15.7553L14.2179 14.9503C14.3938 14.9049 14.5544 14.8132 14.6829 14.6848C14.8114 14.5564 14.9032 14.3959 14.9486 14.22L15.7532 11.1001C15.7681 11.0466 15.8002 10.9995 15.8444 10.966C15.8886 10.9325 15.9425 10.9143 15.998 10.9143C16.0535 10.9143 16.1075 10.9325 16.1517 10.966C16.1959 10.9995 16.2279 11.0466 16.2429 11.1001L17.0469 14.22C17.0923 14.396 17.184 14.5566 17.3126 14.6851C17.4411 14.8136 17.6017 14.9054 17.7777 14.9508L20.8976 15.7548C20.9513 15.7696 20.9986 15.8016 21.0323 15.8459C21.066 15.8901 21.0843 15.9442 21.0843 15.9999C21.0843 16.0556 21.066 16.1097 21.0323 16.154C20.9986 16.1982 20.9513 16.2302 20.8976 16.245L17.7777 17.049C17.6017 17.0944 17.4411 17.1862 17.3126 17.3147C17.184 17.4432 17.0923 17.6038 17.0469 17.7798L16.2424 20.8998C16.2274 20.9532 16.1954 21.0003 16.1512 21.0338C16.107 21.0673 16.053 21.0855 15.9975 21.0855C15.942 21.0855 15.8881 21.0673 15.8439 21.0338C15.7996 21.0003 15.7676 20.9532 15.7527 20.8998L14.9486 17.7798Z'
        stroke={theme.palette.primary.main}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M20.0674 11.4231V13.4573'
        stroke={theme.palette.primary.main}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M21.0859 12.4399H19.0518'
        stroke={theme.palette.primary.main}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M11.9326 18.5425V19.5596'
        stroke={theme.palette.primary.main}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M12.4399 19.0513H11.4229'
        stroke={theme.palette.primary.main}
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
